import Divider from './divider'
export * from './divider'
export default Divider
